import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=44a08d90&"
import script from "./weixin.vue?vue&type=script&lang=js&"
export * from "./weixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports